import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { useContactForm } from '../hooks/useContactForm';

const inputStyle = {
  width: '100%',
  padding: '18px 0 10px',
  border: 'none',
  borderBottom: '1px solid var(--sm-line)',
  background: 'transparent',
  fontSize: 15,
  color: 'var(--sm-navy)',
  outline: 'none',
  fontFamily: 'inherit',
  resize: 'vertical',
};

function Field({ label, value, onChange, type = 'text', textarea = false }) {
  const [focus, setFocus] = useState(false);
  const active = focus || value;
  return (
    <div style={{ position: 'relative' }}>
      <label style={{
        position: 'absolute', left: 0, top: active ? -6 : 18,
        fontSize: active ? 10 : 14,
        letterSpacing: active ? '0.22em' : '0',
        textTransform: active ? 'uppercase' : 'none',
        color: active ? 'var(--sm-gold)' : 'var(--sm-muted)',
        transition: 'all 200ms ease', pointerEvents: 'none',
      }}>
        {label}
      </label>
      {textarea ? (
        <textarea rows={4} value={value} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
                  onChange={(e) => onChange(e.target.value)} style={inputStyle} />
      ) : (
        <input type={type} value={value} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
               onChange={(e) => onChange(e.target.value)} style={inputStyle} />
      )}
    </div>
  );
}

export default function ContactForm() {
  const { form, updateField, submit } = useContactForm();

  return (
    <form onSubmit={submit} style={{ background: 'var(--sm-ivory)', padding: 48, border: '1px solid var(--sm-line)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }} className="form-row">
        <Field label="Your Name" value={form.name} onChange={(v) => updateField('name', v)} />
        <Field label="Your Email" type="email" value={form.email} onChange={(v) => updateField('email', v)} />
      </div>
      <div style={{ marginTop: 24 }}>
        <Field label="Subject" value={form.subject} onChange={(v) => updateField('subject', v)} />
      </div>
      <div style={{ marginTop: 24 }}>
        <Field label="Your Message (optional)" textarea value={form.message} onChange={(v) => updateField('message', v)} />
      </div>
      <button type="submit" className="sm-btn" style={{ marginTop: 32 }}>
        Send Message <Send size={16} />
      </button>
    </form>
  );
}
